const isValueANumber = (value: any) => {
	const coercedValue = Number(value);
	if (isNaN(coercedValue)) {
		return 0;
	}
	return coercedValue;
};
export default isValueANumber;
